<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'record-audio-modal.title'">
      _Grabación de voz
    </span>
  </div>
  <!-- Contenedor -->
  <p class="common-modal__content-header-info"
    [afTranslate]="'record-audio-modal.description'">
    _El mensaje grabado se transcribirá en el editor de texto y el archivo de audio quedará adjunto.
    Ten en cuenta que solo se podrá adjuntar un único audio. Una grabación nueva sustituirá a la anterior.
  </p>
  <div class="record-audio-modal__box-container">
    @if(!recordAudioModal.applyChanges){
      <div class="common-button__container-typetext-checkbox">
        <div  class="common-button__block-typetext-checkbox">
          <div class="common-button__block-button-md-checkbox">
            <button class="common-button__icon-md-checkbox"
              [ngClass]="{'common-button__icon-md-checkbox--selected': recordAudioModal.acceptDistorsion,
                'common-button__icon-md-checkbox--disabled':recordAudioModal.isRecording || recordAudioModal.showPlay}"
              (click)="acceptDistorsionTerms()">
                <i class="common-icon__md"
                  [ngClass]="{'lf-icon-check-full':recordAudioModal.acceptDistorsion,
                    'lf-icon-box-inactive':!recordAudioModal.acceptDistorsion}">
                </i>
            </button>
          </div>
          <div class="common-button__block-text-checkbox">
            <span class="common-button__text-checkbox"
              [ngClass]="{'common-button__text-checkbox--disabled': recordAudioModal.isRecording || recordAudioModal.showPlay}"
              [afTranslate]="'record-audio-modal.voice-distorsion'">
              _Distorsionar voz
            </span>
          </div>
        </div>
      </div>
    }
    <div class="record-audio-modal__box-inner-container">
      <div class="record-audio-modal__inner-container-buttons">
        @if(!recordAudioModal.applyChanges){
          @if (!recordAudioModal.showPlay) {
            <button class="common-button__icon-lg"
              [ngClass]="{'common-button__icon-lg--disabled': recordAudioModal.isRecording && !recordAudioModal.showPlay && recordAudioModal.secondsRecord < 10}"
              (click)="recVoice()">
              <i class=" common-icon__md"
                [ngClass]="{'lf-icon-microphone': !recordAudioModal.isRecording && !recordAudioModal.showPlay,
                  'lf-icon-stop':recordAudioModal.isRecording && !recordAudioModal.showPlay}">
              </i>
            </button>
          }@else{
            <button class="common-button__icon-lg"
              [ngClass]="{'common-button__icon-lg--disabled': recordAudioModal.isRecording && !recordAudioModal.showPlay && recordAudioModal.secondsRecord < 10}"
              (click)="playAudio()">
              <i class=" common-icon__md"
                [ngClass]="recordAudioModal.showPlay && !recordAudioModal.play?'lf-icon-play' : 'lf-icon-stop'">
              </i>
            </button>
          }
          @if (recordAudioModal.blobName === '') {
            <p class="record-audio-modal__record-button-text">
              {{!recordAudioModal.isRecording && !recordAudioModal.showPlay?('record-audio-modal.press-to-talk' | afTranslate) : ('record-audio-modal.stop-record' | afTranslate)}}
            </p>
          }@else{
            <p class="record-audio-modal__record-button-text">
              {{recordAudioModal.blobName}}
            </p>
          }
          <div class="record-audio-modal__container-progress-block">
            <div class="record-audio-modal__progress-text-container">
              <p class="record-audio-modal__progress-text record-audio-modal__progress-text--bold">
                {{recordAudioModal.recordedTime}}
              </p>
              <p class="record-audio-modal__progress-text">
                {{recordAudioModal.maxTime}}
              </p>
            </div>
            <div class="common-progress-indicator__bar-block h-[4px]">
              <div class="common-progress-indicator__bar-inner"
                [progressBar]="recordAudioModal.percentTime">
              </div>
            </div>
          </div>
          @if(recordAudioModal.showDiscard){
            <div class="record-audio-modal__discard-block">
              <button class="common-button__link">
                <a class="common-button__link-text"
                  [afTranslate]="'record-audio-modal.discard-record'"
                  (click)="discardVoiceRecord()">
                  _Descartar Grabacion
                </a>
              </button>
            </div>
          }
        }@else{
          <div class="record-audio-modal__spinner-block">
            <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
              ariaLabel="loading">
            </p-progressSpinner>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="common-modal__footer"
    [ngClass]="{'common-modal__footer--block': recordAudioModal.exceededTime && recordAudioModal.applyChanges}">
    @if(!recordAudioModal.applyChanges){
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">
          _Cancelar
        </span>
      </button>
      @if(recordAudioModal.player !== null){
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title"
            [afTranslate]="'common.confirm'">
            _Confirmar
          </span>
        </button>
      }

    }@else if(recordAudioModal.exceededTime && recordAudioModal.applyChanges){
      <div class="common-status-message__s-container-warning">
        <span-tooltip class="common-status-message__s-title"
          [text]="('record-audio-modal.excceded-time' | afTranslate)">
        </span-tooltip>
        <button class="common-button__icon-xs-noborder"
          (click)="recordAudioModal.exceededTime = !recordAudioModal.exceededTime">
            <i class="lf-icon-close-thick common-icon__sm"></i>
        </button>
      </div>
    }
  </div>
</div>
